import { transientInitialState } from "./initial-state.js";
import { extraReducers } from "./extra-reducers.js";
import { reducers_exports } from "./reducers.js";
import { createSlice } from "@reduxjs/toolkit";
var slice = createSlice({
	name: "transient",
	initialState: transientInitialState,
	reducers: reducers_exports,
	extraReducers
});
var actions = slice.actions;
var reducer = slice.reducer;
//#endregion
export { actions, reducer, slice };

//# sourceMappingURL=slice.js.map